import { userStore } from '@listen360/js_api_client'

import {
  SET_CURRENT_ENVIRONMENT,
  SET_CURRENT_SUBSIDIARY,
  SET_TEMP_ENVIRONMENT
} from '@/store/constants'

export const namespaced = true

export const state = {
  ...userStore.state,
  currentEnvironmentId: '',
  currentSubsidiary: {},
  tempEnvironmentId: ''
}

export const actions = {
  ...userStore.actions,
  setCurrentEnvironment({ commit }, environment) {
    commit(SET_CURRENT_ENVIRONMENT, environment.id)
  },
  setCurrentSubsidiary({ commit }, subsidiary) {
    commit(SET_CURRENT_SUBSIDIARY, subsidiary)
  },
  setTempEnvironment({ commit }, environment) {
    commit(SET_TEMP_ENVIRONMENT, environment.id)
  }
}

export const mutations = {
  ...userStore.mutations,
  [SET_CURRENT_ENVIRONMENT]: (state, id = '') => {
    state.currentEnvironmentId = id
  },
  [SET_CURRENT_SUBSIDIARY]: (state, subsidiary) => {
    state.currentSubsidiary = subsidiary
  },
  [SET_TEMP_ENVIRONMENT]: (state, id = '') => {
    state.tempEnvironmentId = id
  }
}

export const getters = {
  ...userStore.getters,
  currentEnvironment: state =>
    state.accessibleFranchisors.franchisorsMap[state.currentEnvironmentId] ||
    {},
  currentSubsidiary: state => state.currentSubsidiary,
  tempEnvironment: state =>
    state.accessibleFranchisors.franchisorsMap[state.tempEnvironmentId] || {}
}
